import { LOAN_STORY, LOAN_STORY_IMAGE, REPAY_STORY, REPAY_STORY_IMAGE, START_STORY, START_STORY_IMAGE, VOLT_STORY, VOLT_STORY_IMAGE } from "./constant";
export const StoryData = [
    {
        user_id: 1,
        user_image: LOAN_STORY,
        user_name: "Why Loan against MF",
        stories: [
            {
                story_id: 1,
                story_image: LOAN_STORY_IMAGE,
                swipeText: ' ',
                story_text: "Why Loan against MF",
                story_icon: LOAN_STORY,
                onPress: () => console.log('story 1 swiped'),
            },
            {
                story_id: 2,
                story_image: START_STORY_IMAGE,
                swipeText: ' ',
                story_text: "How to get started",
                story_icon: START_STORY,
                onPress: () => console.log('story 2 swiped'),
            },
            {
                story_id: 3,
                story_image: VOLT_STORY_IMAGE,
                swipeText: ' ',
                story_text: "Why use Volt money",
                story_icon: VOLT_STORY,
                onPress: () => console.log('story 3 swiped'),
            },
            {
                story_id: 4,
                story_image: REPAY_STORY_IMAGE,
                swipeText: ' ',
                story_text: "Repayments Simplified",
                story_icon: REPAY_STORY,
                onPress: () => console.log('story 4 swiped'),
            },
        ],
    },
    {
        user_id: 2,
        user_image: START_STORY,
        user_name: 'How to get started',
        stories: [
            {
                story_id: 2,
                story_image: START_STORY_IMAGE,
                swipeText: ' ',
                story_text: "How to get started",
                story_icon: START_STORY,
                onPress: () => console.log('story 2 swiped'),
            },
            {
                story_id: 3,
                story_image: VOLT_STORY_IMAGE,
                swipeText: ' ',
                story_text: "Why use Volt money",
                story_icon: VOLT_STORY,
                onPress: () => console.log('story 3 swiped'),
            },
            {
                story_id: 4,
                story_image: REPAY_STORY_IMAGE,
                swipeText: ' ',
                story_text: "Repayments Simplified",
                story_icon: REPAY_STORY,
                onPress: () => console.log('story 4 swiped'),
            },
        ],
    },
    {
        user_id: 3,
        user_image: VOLT_STORY,
        user_name: 'Why use Volt money',
        stories: [
            {
                story_id: 3,
                story_image: VOLT_STORY_IMAGE,
                swipeText: ' ',
                story_text: "Why use Volt money",
                story_icon: VOLT_STORY,
                onPress: () => console.log('story 3 swiped'),
            },
            {
                story_id: 4,
                story_image: REPAY_STORY_IMAGE,
                swipeText: ' ',
                story_text: "Repayments Simplified",
                story_icon: REPAY_STORY,
                onPress: () => console.log('story 4 swiped'),
            },
        ],
    },
    {
        user_id: 4,
        user_image: REPAY_STORY,
        user_name: 'Repayments Simplified',
        stories: [
            {
                story_id: 4,
                story_image: REPAY_STORY_IMAGE,
                swipeText: ' ',
                story_text: "Repayments Simplified",
                story_icon: REPAY_STORY,
                onPress: () => console.log('story 4 swiped'),
            },
        ],
    },
];
export const AccordionData = [
    {
        id: 1,
        title: "What is loan against mutual funds?",
        description: "Loan against mutual funds (LAMF) allows you to borrow cash by using your mutual fund investments as collateral.\n\nYour mutual fund investments will continue to earn returns and meet your financial goals. And because your loan is backed by mutual funds, you get low interest rates and easy repayment options."
    },
    {
        id: 2,
        title: "What are the benefits?",
        description: `• Flexible withdrawal: It’s an overdraft loan, and you can choose the withdrawal amount as per your need.\n• Low interest rate: You get a low interest rate of 10.49%, even if you have a low CIBIL score.\n• Get debt-free faster: Have extra funds? Using a flexible repayment option, repay your loan whenever you have funds and get debt-free. No foreclosure fee!\n• Avoid CIBIL score drop due to EMI miss: Low on cash? With interest only-EMIs, you can just pay the interest without any penalty.\n• Pay interest only on usage: Interest is charged only for the days you used. No hidden charges!`
    },
    {
        id: 3,
        title: "What is the eligibility criteria?",
        description: "• Eligible limit against your portfolio should be more than Rs. 25,000.\n• You can avail loan even if you have a low credit score or don’t have a credit score."
    },
    {
        id: 4,
        title: "How do I apply?",
        description: "As compared to an offline process which takes 7-10 days, with our hassle-free digital journey you can complete the full application and get approval in 10-15 mins."
    },
    {
        id: 5,
        title: "Are my mutual funds safe?",
        description: "You can avail a loan against mutual funds without losing the ownership of your mutual funds and the returns associated with it.\n\nYour mutual fund investments will continue to earn returns and meet your financial goals. You will continue to see your investments in your Consolidated Account Statement(CAS).\n\nLoan against mutual funds are approved by the RBI. We work with SEBI authorized trusted partners (CAMS and KFintech) to provide a secure and hassle-free process."
    },
    {
        id: 6,
        title: "How is my credit limit calculated?",
        description: "Eligible credit limit is based on the current value of your mutual fund investments.\n\nFactors considered for calculating credit limit include investment portfolio of the mutual fund, historical performance, and market fluctuation risks.\n\nWe provide up to 90% of the value for debt mutual funds, and up to 50% of the value for equity mutual funds. Ineligible mutual funds are not included for calculating credit limit.\n\nReasons for ineligibility include locked units, demat mutual funds, and funds that are not approved for pledging by lenders."
    }
];
